// @ts-nocheck


export const localeCodes = [
  "en",
  "ar",
  "tr",
  "es",
  "fa"
]

export const localeMessages = { 
  "en": [
      { key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__app_locales_en_json" */), cache: true },
  ],
  "ar": [
      { key: "../locales/ar.json", load: () => import("../locales/ar.json" /* webpackChunkName: "locale__app_locales_ar_json" */), cache: true },
  ],
  "tr": [
      { key: "../locales/tr.json", load: () => import("../locales/tr.json" /* webpackChunkName: "locale__app_locales_tr_json" */), cache: true },
  ],
  "es": [
      { key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__app_locales_es_json" */), cache: true },
  ],
  "fa": [
      { key: "../locales/fa.json", load: () => import("../locales/fa.json" /* webpackChunkName: "locale__app_locales_fa_json" */), cache: true },
  ],
}

export const resolveNuxtI18nOptions = async (context) => {
  const nuxtI18nOptions = {
  "experimental": {
    "jsTsFormatResource": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "name": "English",
      "code": "en",
      "dir": "ltr",
      "iso": "en-US",
      "google_code": "en-US",
      "responsive_voice_code": "US English Female",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "name": "Arabic",
      "code": "ar",
      "dir": "rtl",
      "iso": "ar-XA",
      "google_code": "en-US",
      "responsive_voice_code": "Arabic Female",
      "files": [
        "locales/ar.json"
      ]
    },
    {
      "name": "Turkish",
      "code": "tr",
      "dir": "ltr",
      "iso": "tr-TR",
      "google_code": "tr-TR",
      "responsive_voice_code": "Turkish Female",
      "files": [
        "locales/tr.json"
      ]
    },
    {
      "name": "Spanish",
      "code": "es",
      "dir": "ltr",
      "iso": "es-ES",
      "google_code": "es-ES",
      "responsive_voice_code": "Spanish Female",
      "files": [
        "locales/es.json"
      ]
    },
    {
      "name": "Persian",
      "code": "fa",
      "dir": "rtl",
      "iso": "fa-IR",
      "google_code": "en-US",
      "responsive_voice_code": "Arabic Female",
      "files": [
        "locales/fa.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales/",
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}
  
  const vueI18nConfigLoader = async loader => {
    const config = await loader().then(r => r.default || r)
    if (typeof config === 'object') return config
    if (typeof config === 'function') return await config()
    return {}
  }

  const deepCopy = (src, des, predicate) => {
    for (const key in src) {
      if (typeof src[key] === 'object') {
        if (!(typeof des[key] === 'object')) des[key] = {}
        deepCopy(src[key], des[key], predicate)
      } else {
        if (predicate) {
          if (predicate(src[key], des[key])) {
            des[key] = src[key]
          }
        } else {
          des[key] = src[key]
        }
      }
    }
  }
  
  const mergeVueI18nConfigs = async (loader) => {
    const layerConfig = await vueI18nConfigLoader(loader)
    const cfg = layerConfig || {}
    
    for (const [k, v] of Object.entries(cfg)) {
      if(nuxtI18nOptions.vueI18n?.[k] === undefined || typeof nuxtI18nOptions.vueI18n?.[k] !== 'object') {
        nuxtI18nOptions.vueI18n[k] = v
      } else {
        deepCopy(v, nuxtI18nOptions.vueI18n[k])
      }
    }
  }

  nuxtI18nOptions.vueI18n = { messages: {} }
  
    
  return nuxtI18nOptions
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "jsTsFormatResource": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const nuxtI18nInternalOptions = {
  "__normalizedLocales": [
    {
      "name": "English",
      "code": "en",
      "dir": "ltr",
      "iso": "en-US",
      "google_code": "en-US",
      "responsive_voice_code": "US English Female",
      "files": [
        {
          "path": "locales/en.json"
        }
      ]
    },
    {
      "name": "Arabic",
      "code": "ar",
      "dir": "rtl",
      "iso": "ar-XA",
      "google_code": "en-US",
      "responsive_voice_code": "Arabic Female",
      "files": [
        {
          "path": "locales/ar.json"
        }
      ]
    },
    {
      "name": "Turkish",
      "code": "tr",
      "dir": "ltr",
      "iso": "tr-TR",
      "google_code": "tr-TR",
      "responsive_voice_code": "Turkish Female",
      "files": [
        {
          "path": "locales/tr.json"
        }
      ]
    },
    {
      "name": "Spanish",
      "code": "es",
      "dir": "ltr",
      "iso": "es-ES",
      "google_code": "es-ES",
      "responsive_voice_code": "Spanish Female",
      "files": [
        {
          "path": "locales/es.json"
        }
      ]
    },
    {
      "name": "Persian",
      "code": "fa",
      "dir": "rtl",
      "iso": "fa-IR",
      "google_code": "en-US",
      "responsive_voice_code": "Arabic Female",
      "files": [
        {
          "path": "locales/fa.json"
        }
      ]
    }
  ]
}
 
export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
